const state = {
   apartment: null,
}
const getters = {
   apartment: (state) => state.apartment,
}
const mutations = {
   apartment(state, payload) {
      state.apartment = payload
   },
}
const actions = {
   setApartment({ commit, state }, apartment) {
      commit('apartment', apartment)
   },
}

export default {
   actions,
   state,
   getters,
   mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/apartments.js